import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { useApiErrorHandler } from '../../../useApiErrorHandler'

interface DeleteConversationParams {
  id: string
}

const deleteConversation = async ({ id }: DeleteConversationParams): Promise<void> => {
  await api.delete(`/ft_chatbot/conversations/${id}`)
}

export const useFtChatbotDeleteConversation = () => {
  const queryClient = useQueryClient()
  const handleApiError = useApiErrorHandler()

  return useMutation<void, Error, DeleteConversationParams>({
    mutationFn: deleteConversation,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['chatbot-conversations'] }),
    onError: handleApiError,
  })
}
